let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jZxab")).then(() => parcelRequire('1bh7m'));